export class templateAnalyzerText {
    static readonly ObservationWarning = 'Allow select maximum 10 observations only !';
    static readonly SettingWarning = 'Allow select maximum 10 settings only !';
    static readonly NoObservationsAndSettings = 'Please select at least one observation or setting !';
    static readonly NoDevices = 'No any devices associated with this template !';
}